import React, { useContext } from "react";
import { exchanger } from "../../rbac-consts";
import Can from "../can/Can";
import { AppContext } from "../../App";

import { default as MasterExchangeTabsContainer } from "./master/ExchangeTabsContainer";
import { default as ClientExchangeHistoryContainer } from "./client/history/ExchangeHistoryContainer";
import { default as AdminExchangeHistoryContainer } from "./admin/history/ExchangeHistoryContainer";

const Exchange = () => {
  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={exchanger.MASTER}
        yes={() => (
          <MasterExchangeTabsContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={exchanger.ADMIN}
        yes={() => (
          <AdminExchangeHistoryContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={exchanger.USER}
        yes={() => (
          <ClientExchangeHistoryContainer />
        )}
      />
    </>
  );
};

export default Exchange;